export default __webpack_public_path__ + "static/media/activationImage.e5024967.png";